var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bairun-container" },
    [
      _c(
        "div",
        { staticClass: "search-term" },
        [
          _c(
            "el-form",
            { attrs: { inline: true, model: _vm.searchInfo } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "选择油站" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "搜索条件"
                      },
                      model: {
                        value: _vm.searchInfo.stationId,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "stationId", $$v)
                        },
                        expression: "searchInfo.stationId"
                      }
                    },
                    _vm._l(_vm.stationOptions, function(item) {
                      return _c("el-option", {
                        key: item.ID,
                        attrs: { label: item.stationName, value: item.ID }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                    [_vm._v("查询")]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onCreate } },
                    [_vm._v("新建卸油单据")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: { data: _vm.tableData, stripe: "", border: "" }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "tankInNo", label: "编号", width: "180px" }
          }),
          _c("el-table-column", {
            attrs: { prop: "tankInName", label: "卸油单据名称", width: "180px" }
          }),
          _c("el-table-column", {
            attrs: { label: "油站名称", prop: "stationId", width: "200px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm.getStationName(scope.row.stationId)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", { attrs: { label: "油品", prop: "oilCodes" } }),
          _c("el-table-column", {
            attrs: { label: "入罐(吨)", prop: "giveInTon" }
          }),
          _c("el-table-column", {
            attrs: { label: "实际入罐(吨)", prop: "oilInTon" }
          }),
          _c("el-table-column", {
            attrs: { label: "入罐(升)", prop: "giveInLiters" }
          }),
          _c("el-table-column", {
            attrs: { label: "实际入罐(升)", prop: "oilInLiters" }
          }),
          _c("el-table-column", {
            attrs: { label: "损耗(升)", prop: "oilLossLiters" }
          }),
          _c("el-table-column", {
            attrs: { label: "操作日期", prop: "UpdatedAt", width: "180px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("formatDate")(scope.row.UpdatedAt)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "250px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        staticClass: "table-button",
                        attrs: {
                          size: "small",
                          disabled: scope.row.tankInStatus != 1
                        },
                        on: {
                          click: function($event) {
                            return _vm.onUnloadOil(scope.row)
                          }
                        }
                      },
                      [_vm._v("卸油")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "table-button",
                        staticStyle: { "margin-right": "2px" },
                        attrs: {
                          slot: "reference",
                          size: "small",
                          disabled: scope.row.tankInStatus == 3
                        },
                        on: {
                          click: function($event) {
                            return _vm.edit(scope.row)
                          }
                        },
                        slot: "reference"
                      },
                      [_vm._v("编辑")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "table-button",
                        staticStyle: { "margin-right": "2px" },
                        attrs: { slot: "reference", size: "small" },
                        on: {
                          click: function($event) {
                            return _vm.preview(scope.row)
                          }
                        },
                        slot: "reference"
                      },
                      [_vm._v("预览")]
                    ),
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          effect: "dark",
                          content: "提交后不能再修改",
                          placement: "top-end"
                        }
                      },
                      [
                        _c(
                          "el-popconfirm",
                          {
                            attrs: { title: "请问是否提交？提交后不能再修改" },
                            on: {
                              confirm: function($event) {
                                return _vm.submit(scope.row)
                              }
                            }
                          },
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "table-button",
                                staticStyle: { "margin-right": "2px" },
                                attrs: {
                                  slot: "reference",
                                  disabled: scope.row.tankInStatus == 3,
                                  size: "small",
                                  type: "primary"
                                },
                                slot: "reference"
                              },
                              [_vm._v("提交")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            width: "30%",
            title: "创建卸油单据",
            visible: _vm.addDialogVisible,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.addDialogVisible = $event
            },
            close: _vm.dialogClose
          }
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "100px" } },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "bairun-required",
                  attrs: { label: "选择油站" }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "搜索条件"
                      },
                      model: {
                        value: _vm.createFormData.stationId,
                        callback: function($$v) {
                          _vm.$set(_vm.createFormData, "stationId", $$v)
                        },
                        expression: "createFormData.stationId"
                      }
                    },
                    _vm._l(_vm.stationOptions, function(item) {
                      return _c("el-option", {
                        key: item.ID,
                        attrs: { label: item.stationName, value: item.ID }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "bairun-required",
                  attrs: { label: "单据名称" }
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.createFormData.tankInName,
                      callback: function($$v) {
                        _vm.$set(_vm.createFormData, "tankInName", $$v)
                      },
                      expression: "createFormData.tankInName"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "text-align": "right", color: "#909399" } },
            [_vm._v("备注：卸油信息根据日期生成，可自行修改")]
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.addDialogVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onCreateSave } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.unloadOilDialogVisible,
            top: "5vh",
            width: "80%",
            fullscreen: _vm.dialogFull,
            title: _vm.unloadOilDialogTitle
          },
          on: {
            "update:visible": function($event) {
              _vm.unloadOilDialogVisible = $event
            },
            close: function() {
              _vm.clearAllInterval()
              _vm.dialogClose()
            }
          }
        },
        [
          _c(
            "el-row",
            { staticStyle: { "margin-bottom": "20px" }, attrs: { gutter: 20 } },
            _vm._l(_vm.yeweiyiTableData, function(item, index) {
              return _c(
                "el-col",
                { attrs: { xs: 24, sm: 12, md: 10, lg: 6, xl: 6 } },
                [
                  _c(
                    "el-card",
                    {
                      class:
                        item.tankInStatus == 1
                          ? "el-card-" + item.oilCode + " danger"
                          : "el-card-" + item.oilCode,
                      attrs: { shadow: "never" }
                    },
                    [
                      _c("span", { staticStyle: { float: "left" } }, [
                        _vm._v(
                          "更新时间：" +
                            _vm._s(_vm._f("formatDate")(item.tankUpdatedAt))
                        )
                      ]),
                      _c(
                        "span",
                        { staticStyle: { float: "right" } },
                        [
                          item.yeweiyiStatus == 2
                            ? _c(
                                "el-tag",
                                {
                                  attrs: {
                                    effect: "dark",
                                    size: "small",
                                    type: "info"
                                  }
                                },
                                [_vm._v("未接通")]
                              )
                            : item.alarmStatus == 2
                            ? _c(
                                "el-tag",
                                {
                                  attrs: {
                                    effect: "plain",
                                    size: "small",
                                    type: "danger"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatAlarmStatusName")(item)
                                    )
                                  )
                                ]
                              )
                            : _c(
                                "el-tag",
                                {
                                  attrs: {
                                    effect: "plain",
                                    size: "small",
                                    type: "primary"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatAlarmStatusName")(item)
                                    )
                                  )
                                ]
                              )
                        ],
                        1
                      ),
                      _c("div", { staticStyle: { clear: "both" } }),
                      _c("div", { staticStyle: { float: "left" } }, [
                        _c(
                          "div",
                          {
                            staticClass: "box",
                            style: {
                              "--height": _vm.percentage(
                                item.oilCapacity,
                                item.emptyCapacity,
                                item.waterCapacity
                              )
                            }
                          },
                          [
                            _c("div", { staticClass: "text1" }, [
                              _vm._v(" " + _vm._s(item.tankNum) + " ")
                            ]),
                            _c("div", { staticClass: "text2" }, [
                              _vm._v(" " + _vm._s(item.oilCode) + "# ")
                            ])
                          ]
                        )
                      ]),
                      _c("div", { staticStyle: { float: "right" } }, [
                        _c("div", { staticClass: "data-box" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "data-text-top text-size-lg text-align text-bold"
                            },
                            [_vm._v(" " + _vm._s(item.oilHeight) + " ")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "data-text-bottom text-size-xs text-align padding-top-xs"
                            },
                            [_vm._v(" 油高(mm) ")]
                          )
                        ]),
                        _c("div", { staticClass: "data-box" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "data-text-top text-size-lg text-align text-bold"
                            },
                            [_vm._v(" " + _vm._s(item.waterHeight) + " ")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "data-text-bottom text-size-xs text-align padding-top-xs"
                            },
                            [_vm._v(" 水高(mm) ")]
                          )
                        ]),
                        _c("div", { staticClass: "data-box" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "data-text-top text-size-lg text-align text-bold"
                            },
                            [_vm._v(" " + _vm._s(item.oilCapacity) + " ")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "data-text-bottom text-size-xs text-align padding-top-xs"
                            },
                            [_vm._v(" 油体积(L) ")]
                          )
                        ]),
                        _c("div", { staticClass: "data-box" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "data-text-top text-size-lg text-align text-bold"
                            },
                            [_vm._v(" " + _vm._s(item.emptyCapacity) + " ")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "data-text-bottom text-size-xs text-align padding-top-xs"
                            },
                            [_vm._v(" 空容(L) ")]
                          )
                        ])
                      ]),
                      _c("div", { staticStyle: { clear: "both" } }),
                      _c(
                        "div",
                        { staticClass: "other-data text-size-xs text-black" },
                        [
                          _c("div", { staticClass: "other-data-box" }, [
                            _c("div", { staticClass: "other-data-text" }, [
                              _c("span", [_vm._v("温度: ")]),
                              _vm._v(_vm._s(item.oilTemperature) + "°C ")
                            ]),
                            _c(
                              "div",
                              {
                                staticClass: "other-data-text",
                                staticStyle: { "margin-left": "10px" }
                              },
                              [
                                _c("span", [_vm._v("水体积: ")]),
                                _vm._v(_vm._s(item.waterCapacity) + "L ")
                              ]
                            )
                          ])
                        ]
                      ),
                      item.tankInStatus == 1
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "margin-top": "10px",
                                float: "left"
                              }
                            },
                            [
                              _c("div", [
                                _vm._v(
                                  " 开始卸油：" +
                                    _vm._s(
                                      _vm._f("formatDate2")(item.tankInOptStart)
                                    ) +
                                    " "
                                )
                              ]),
                              item.timeHour == "0" && item.timeMinute == "0"
                                ? _c("div", { staticClass: "timer-text" }, [
                                    _vm._v(
                                      " 卸油中：" +
                                        _vm._s(item.timeSecond + "秒") +
                                        " "
                                    )
                                  ])
                                : item.timeHour == "0"
                                ? _c("div", { staticClass: "timer-text" }, [
                                    _vm._v(
                                      " 卸油中：" +
                                        _vm._s(
                                          item.timeMinute +
                                            "分" +
                                            item.timeSecond +
                                            "秒"
                                        ) +
                                        " "
                                    )
                                  ])
                                : item.timeDay == "0"
                                ? _c("div", { staticClass: "timer-text" }, [
                                    _vm._v(
                                      " 卸油中：" +
                                        _vm._s(
                                          item.timeHour +
                                            "小时" +
                                            item.timeMinute +
                                            "分" +
                                            item.timeSecond +
                                            "秒"
                                        ) +
                                        " "
                                    )
                                  ])
                                : _c("div", { staticClass: "timer-text" }, [
                                    _vm._v(
                                      " 卸油中：" +
                                        _vm._s(
                                          item.timeDay +
                                            "天" +
                                            item.timeHour +
                                            "小时" +
                                            item.timeMinute +
                                            "分" +
                                            item.timeSecond +
                                            "秒"
                                        ) +
                                        " "
                                    )
                                  ])
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          staticStyle: { "margin-top": "10px", float: "right" }
                        },
                        [
                          item.tankInStatus == 0
                            ? _c(
                                "el-button",
                                {
                                  attrs: { size: "small", type: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.startUnloadOil(item)
                                    }
                                  }
                                },
                                [_vm._v("开始卸油")]
                              )
                            : _vm._e(),
                          item.tankInStatus == 1
                            ? _c(
                                "el-button",
                                {
                                  staticStyle: { "margin-right": "10px" },
                                  attrs: { size: "small", type: "danger" },
                                  on: {
                                    click: function($event) {
                                      return _vm.endUnloadOil(item)
                                    }
                                  }
                                },
                                [_vm._v("结束卸油")]
                              )
                            : _vm._e(),
                          item.tankInStatus == 1
                            ? _c(
                                "el-popconfirm",
                                {
                                  attrs: { title: "请问是否取消卸油？" },
                                  on: {
                                    confirm: function($event) {
                                      return _vm.updateUnloadOil(item, 0)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [_vm._v("取消卸油")]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c("div", { staticStyle: { clear: "both" } })
                    ]
                  )
                ],
                1
              )
            }),
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.startDialogVisible, top: "5vh", width: "90%" },
          on: {
            "update:visible": function($event) {
              _vm.startDialogVisible = $event
            },
            close: _vm.dialogClose
          }
        },
        [
          _c("template", { slot: "title" }, [
            _c("div", { staticClass: "avue-crud__dialog__header" }, [
              _c("span", { staticClass: "el-dialog__title" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.formTable.length > 0 ? _vm.formTable[0].tankNum : ""
                    ) +
                    "号灌 - " +
                    _vm._s(
                      _vm.formTable.length > 0 ? _vm.formTable[0].oilCode : ""
                    ) +
                    "# - 开始卸油登记 "
                )
              ])
            ])
          ]),
          _c(
            "span",
            [
              _c("el-scrollbar", { staticStyle: { width: "100%" } }, [
                _c(
                  "table",
                  { attrs: { border: "1", width: "100%" } },
                  [
                    _c("tr", [
                      _c("td", { attrs: { width: "100%", colspan: 10 } }, [
                        _c(
                          "h2",
                          {
                            staticStyle: {
                              "font-size": "20px",
                              padding: "15px"
                            }
                          },
                          [
                            _c("u", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.getStationName(
                                      _vm.formTable.length > 0
                                        ? _vm.formTable[0].stationId
                                        : 0
                                    )
                                  ) +
                                  " - " +
                                  _vm._s(
                                    _vm.formTable.length > 0
                                      ? _vm.formTable[0].tankNum
                                      : ""
                                  ) +
                                  "号灌 - " +
                                  _vm._s(
                                    _vm.formTable.length > 0
                                      ? _vm.formTable[0].oilCode
                                      : ""
                                  ) +
                                  "#"
                              )
                            ]),
                            _vm._v(" - 开始卸油登记")
                          ]
                        )
                      ])
                    ]),
                    _c("tr", [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "font-size": "18px",
                            padding: "10px",
                            "font-weight": "bold"
                          },
                          attrs: { width: "100%", colspan: 10 }
                        },
                        [
                          _c(
                            "span",
                            { staticStyle: { "text-align": "right" } },
                            [_vm._v("年")]
                          ),
                          _c(
                            "span",
                            { staticStyle: { "text-align": "center" } },
                            [_vm._v("      月")]
                          ),
                          _c(
                            "span",
                            { staticStyle: { "text-align": "left" } },
                            [_vm._v("      日")]
                          )
                        ]
                      )
                    ]),
                    _c("tr", [
                      _c("td", { attrs: { width: "10%" } }, [_vm._v("供应商")]),
                      _c("td", { attrs: { width: "10%" } }, [
                        _vm._v("发油单位")
                      ]),
                      _c("td", { attrs: { width: "10%" } }, [
                        _vm._v("油罐编号")
                      ]),
                      _c("td", { attrs: { width: "10%" } }, [
                        _vm._v("油品型号")
                      ]),
                      _c("td", { attrs: { width: "10%" } }, [
                        _vm._v("提油单号")
                      ]),
                      _c("td", { attrs: { width: "10%" } }, [
                        _vm._v("运输单号")
                      ]),
                      _c("td", { attrs: { width: "10%" } }, [
                        _vm._v("卸油前油罐温度"),
                        _c("br"),
                        _vm._v("（℃）")
                      ]),
                      _c("td", { attrs: { width: "10%" } }, [
                        _vm._v("卸油前尺高度"),
                        _c("br"),
                        _vm._v("（mm）")
                      ]),
                      _c("td", { attrs: { width: "10%" } }, [
                        _vm._v("卸油前尺升数"),
                        _c("br"),
                        _vm._v("（升）")
                      ])
                    ]),
                    _vm._l(_vm.formTable, function(item, index) {
                      return _c("tr", { key: index }, [
                        _c(
                          "td",
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "paperview-input-text",
                                attrs: {
                                  filterable: "",
                                  clearable: "",
                                  placeholder: "请选择（必填）"
                                },
                                model: {
                                  value: _vm.formTable[index].oilSupplierNo,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formTable[index],
                                      "oilSupplierNo",
                                      $$v
                                    )
                                  },
                                  expression: "formTable[index].oilSupplierNo"
                                }
                              },
                              _vm._l(_vm.supplierList, function(item) {
                                return _c("el-option", {
                                  key: item.ID,
                                  attrs: {
                                    label: item.supplierName,
                                    value: item.oilSupplierNo
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "td",
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "paperview-input-text",
                                attrs: {
                                  filterable: "",
                                  clearable: "",
                                  placeholder: "请选择（必填）"
                                },
                                model: {
                                  value: _vm.formTable[index].depotNo,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formTable[index],
                                      "depotNo",
                                      $$v
                                    )
                                  },
                                  expression: "formTable[index].depotNo"
                                }
                              },
                              _vm._l(_vm.oildepotList, function(item) {
                                return _c("el-option", {
                                  key: item.ID,
                                  attrs: {
                                    label: item.depotName,
                                    value: item.depotNo
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "td",
                          [
                            _c("el-input", {
                              staticClass: "paperview-input-text",
                              attrs: { placeholder: "请填写（必填）" },
                              nativeOn: {
                                input: function($event) {
                                  return _vm.onInputDecimal($event)
                                }
                              },
                              model: {
                                value: _vm.formTable[index].tankNumTemp,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formTable[index],
                                    "tankNumTemp",
                                    $$v
                                  )
                                },
                                expression: "formTable[index].tankNumTemp"
                              }
                            })
                          ],
                          1
                        ),
                        _c("td", { staticClass: "table-bg" }, [
                          _vm._v(
                            " " + _vm._s(_vm.formTable[index].oilCode) + "# "
                          )
                        ]),
                        _c(
                          "td",
                          [
                            _c("el-input", {
                              staticClass: "paperview-input-text",
                              attrs: { placeholder: "请填写（必填）" },
                              model: {
                                value: _vm.formTable[index].withdrawalTicketNo,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formTable[index],
                                    "withdrawalTicketNo",
                                    $$v
                                  )
                                },
                                expression:
                                  "formTable[index].withdrawalTicketNo"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "td",
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "paperview-input-text",
                                attrs: {
                                  filterable: "",
                                  clearable: "",
                                  placeholder: "请选择（必填）"
                                },
                                model: {
                                  value: _vm.formTable[index].transportNo,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formTable[index],
                                      "transportNo",
                                      $$v
                                    )
                                  },
                                  expression: "formTable[index].transportNo"
                                }
                              },
                              _vm._l(_vm.transportList, function(item) {
                                return _c("el-option", {
                                  key: item.ID,
                                  attrs: {
                                    label: item.transportName,
                                    value: item.transportNo
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "td",
                          [
                            _c("el-input", {
                              staticClass: "paperview-input-text",
                              attrs: { placeholder: "请填写（必填）" },
                              nativeOn: {
                                input: function($event) {
                                  return _vm.onInputDecimal($event)
                                }
                              },
                              model: {
                                value:
                                  _vm.formTable[index].beforeTankTemperature,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formTable[index],
                                    "beforeTankTemperature",
                                    $$v
                                  )
                                },
                                expression:
                                  "formTable[index].beforeTankTemperature"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "td",
                          [
                            _c("el-input", {
                              staticClass: "paperview-input-text",
                              attrs: { placeholder: "请填写（必填）" },
                              nativeOn: {
                                input: function($event) {
                                  return _vm.onInputDecimal($event)
                                }
                              },
                              model: {
                                value: _vm.formTable[index].beforeOilHeight,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formTable[index],
                                    "beforeOilHeight",
                                    $$v
                                  )
                                },
                                expression: "formTable[index].beforeOilHeight"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "td",
                          [
                            _c("el-input", {
                              staticClass: "paperview-input-text",
                              attrs: { placeholder: "请填写（必填）" },
                              nativeOn: {
                                input: function($event) {
                                  return _vm.onInputDecimal($event)
                                }
                              },
                              model: {
                                value: _vm.formTable[index].beforeOilCapacity,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formTable[index],
                                    "beforeOilCapacity",
                                    $$v
                                  )
                                },
                                expression: "formTable[index].beforeOilCapacity"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    })
                  ],
                  2
                )
              ])
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.startDialogVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.doStartUnloadOil }
                },
                [_vm._v("开始卸油")]
              )
            ],
            1
          )
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.endDialogVisible, top: "5vh", width: "90%" },
          on: {
            "update:visible": function($event) {
              _vm.endDialogVisible = $event
            },
            close: _vm.dialogClose
          }
        },
        [
          _c("template", { slot: "title" }, [
            _c("div", { staticClass: "avue-crud__dialog__header" }, [
              _c("span", { staticClass: "el-dialog__title" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.formTable.length > 0 ? _vm.formTable[0].tankNum : ""
                    ) +
                    "号灌 - " +
                    _vm._s(
                      _vm.formTable.length > 0 ? _vm.formTable[0].oilCode : ""
                    ) +
                    "# - 结束卸油登记 "
                )
              ])
            ])
          ]),
          _c(
            "span",
            [
              _c("el-scrollbar", { staticStyle: { width: "100%" } }, [
                _c(
                  "table",
                  { attrs: { border: "1", width: "100%" } },
                  [
                    _c("tr", [
                      _c("td", { attrs: { width: "100%", colspan: 12 } }, [
                        _c(
                          "h2",
                          {
                            staticStyle: {
                              "font-size": "20px",
                              padding: "15px"
                            }
                          },
                          [
                            _c("u", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.getStationName(
                                      _vm.formTable.length > 0
                                        ? _vm.formTable[0].stationId
                                        : 0
                                    )
                                  ) +
                                  " - " +
                                  _vm._s(
                                    _vm.formTable.length > 0
                                      ? _vm.formTable[0].tankNum
                                      : ""
                                  ) +
                                  "号灌 - " +
                                  _vm._s(
                                    _vm.formTable.length > 0
                                      ? _vm.formTable[0].oilCode
                                      : ""
                                  ) +
                                  "#"
                              )
                            ]),
                            _vm._v(" - 结束卸油登记")
                          ]
                        )
                      ])
                    ]),
                    _c("tr", [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "font-size": "18px",
                            padding: "10px",
                            "font-weight": "bold"
                          },
                          attrs: { width: "100%", colspan: 12 }
                        },
                        [
                          _c(
                            "span",
                            { staticStyle: { "text-align": "right" } },
                            [_vm._v("年")]
                          ),
                          _c(
                            "span",
                            { staticStyle: { "text-align": "center" } },
                            [_vm._v("      月")]
                          ),
                          _c(
                            "span",
                            { staticStyle: { "text-align": "left" } },
                            [_vm._v("      日")]
                          )
                        ]
                      )
                    ]),
                    _c("tr", [
                      _c("td", { attrs: { width: "10%" } }, [
                        _vm._v("卸油后尺高度"),
                        _c("br"),
                        _vm._v("（mm）")
                      ]),
                      _c("td", { attrs: { width: "10%" } }, [
                        _vm._v("卸油后尺升数"),
                        _c("br"),
                        _vm._v("（升）")
                      ]),
                      _c("td", { attrs: { width: "10%" } }, [
                        _vm._v("卸油后油罐温度")
                      ]),
                      _c("td", { attrs: { width: "10%" } }, [
                        _vm._v("油温"),
                        _c("br"),
                        _vm._v("（视温℃）")
                      ]),
                      _c("td", { attrs: { width: "10%" } }, [
                        _vm._v("到站密度"),
                        _c("br"),
                        _vm._v("（视密）")
                      ]),
                      _c(
                        "td",
                        { attrs: { width: "10%" } },
                        [
                          _c("el-tooltip", { attrs: { placement: "top" } }, [
                            _c(
                              "div",
                              {
                                staticClass: "tips-content",
                                attrs: { slot: "content" },
                                slot: "content"
                              },
                              [_c("span", [_vm._v("备注哪个油站分卸多少吨")])]
                            ),
                            _c("span", [_vm._v("备注情况")])
                          ])
                        ],
                        1
                      )
                    ]),
                    _vm._l(_vm.formTable, function(item, index) {
                      return _c("tr", { key: index }, [
                        _c(
                          "td",
                          [
                            _c("el-input", {
                              staticClass: "paperview-input-text",
                              attrs: { placeholder: "请填写（必填）" },
                              nativeOn: {
                                input: function($event) {
                                  return _vm.onInputDecimal($event)
                                }
                              },
                              model: {
                                value: _vm.formTable[index].afterOilHeight,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formTable[index],
                                    "afterOilHeight",
                                    $$v
                                  )
                                },
                                expression: "formTable[index].afterOilHeight"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "td",
                          [
                            _c("el-input", {
                              staticClass: "paperview-input-text",
                              attrs: { placeholder: "请填写（必填）" },
                              nativeOn: {
                                input: function($event) {
                                  return _vm.onInputDecimal($event)
                                }
                              },
                              model: {
                                value: _vm.formTable[index].afterOilCapacity,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formTable[index],
                                    "afterOilCapacity",
                                    $$v
                                  )
                                },
                                expression: "formTable[index].afterOilCapacity"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "td",
                          [
                            _c("el-input", {
                              staticClass: "paperview-input-text",
                              attrs: { placeholder: "请填写（必填）" },
                              nativeOn: {
                                input: function($event) {
                                  return _vm.onInputDecimal($event)
                                }
                              },
                              model: {
                                value:
                                  _vm.formTable[index].afterTankTemperature,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formTable[index],
                                    "afterTankTemperature",
                                    $$v
                                  )
                                },
                                expression:
                                  "formTable[index].afterTankTemperature"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "td",
                          [
                            _c("el-input", {
                              staticClass: "paperview-input-text",
                              attrs: { placeholder: "请填写（必填）" },
                              nativeOn: {
                                input: function($event) {
                                  return _vm.onInputDecimal($event)
                                }
                              },
                              model: {
                                value: _vm.formTable[index].oilTemperature,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formTable[index],
                                    "oilTemperature",
                                    $$v
                                  )
                                },
                                expression: "formTable[index].oilTemperature"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "td",
                          [
                            _c("el-input", {
                              staticClass: "paperview-input-text",
                              attrs: { placeholder: "请填写（必填）" },
                              nativeOn: {
                                input: function($event) {
                                  return _vm.onInputDecimal($event)
                                }
                              },
                              model: {
                                value: _vm.formTable[index].oilDensity,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formTable[index],
                                    "oilDensity",
                                    $$v
                                  )
                                },
                                expression: "formTable[index].oilDensity"
                              }
                            })
                          ],
                          1
                        ),
                        _c("td", [
                          _c(
                            "div",
                            [
                              _c(
                                "el-form",
                                { attrs: { model: _vm.formTable[index] } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticStyle: {
                                        margin: "0",
                                        padding: "0"
                                      },
                                      attrs: { "label-width": "0" }
                                    },
                                    [
                                      _c("el-input", {
                                        staticClass: "paperview-input-text",
                                        attrs: { placeholder: "请填写" },
                                        model: {
                                          value: _vm.formTable[index].remark,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formTable[index],
                                              "remark",
                                              $$v
                                            )
                                          },
                                          expression: "formTable[index].remark"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ])
                      ])
                    })
                  ],
                  2
                )
              ])
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.endDialogVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.doEndUnloadOil }
                },
                [_vm._v("结束卸油")]
              )
            ],
            1
          )
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.saveState ? _vm.handleClose : "",
            visible: _vm.dialogVisible,
            top: "5vh",
            width: "80%",
            fullscreen: _vm.dialogFull
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.dialogClose
          }
        },
        [
          _c("template", { slot: "title" }, [
            _c("div", { staticClass: "avue-crud__dialog__header" }, [
              _c("span", { staticClass: "el-dialog__title" }, [
                _vm._v(" " + _vm._s(_vm.previewState ? "预览" : "编辑") + " ")
              ]),
              _c(
                "div",
                {
                  staticClass: "avue-crud__dialog__menu",
                  on: {
                    click: function($event) {
                      _vm.dialogFull
                        ? (_vm.dialogFull = false)
                        : (_vm.dialogFull = true)
                    }
                  }
                },
                [_c("i", { staticClass: "el-icon-full-screen" })]
              )
            ])
          ]),
          _c(
            "span",
            [
              _c("el-scrollbar", { staticStyle: { width: "100%" } }, [
                _c(
                  "table",
                  {
                    attrs: {
                      border: "1",
                      width: _vm.previewState ? "1880" : "2180"
                    }
                  },
                  [
                    _c("tr", [
                      _c(
                        "td",
                        { attrs: { width: "100%", colspan: _vm.colspanNum } },
                        [
                          _c(
                            "h2",
                            {
                              staticStyle: {
                                "font-size": "20px",
                                padding: "15px"
                              }
                            },
                            [
                              _c("u", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.getStationName(_vm.formData.stationId)
                                    ) +
                                    " "
                                )
                              ]),
                              _vm._v("卸油验收入库单")
                            ]
                          )
                        ]
                      )
                    ]),
                    _c("tr", [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "font-size": "18px",
                            padding: "10px",
                            "font-weight": "bold"
                          },
                          attrs: { width: "100%", colspan: _vm.colspanNum }
                        },
                        [
                          _c(
                            "span",
                            { staticStyle: { "text-align": "right" } },
                            [_vm._v("年")]
                          ),
                          _c(
                            "span",
                            { staticStyle: { "text-align": "center" } },
                            [_vm._v("      月")]
                          ),
                          _c(
                            "span",
                            { staticStyle: { "text-align": "left" } },
                            [_vm._v("      日")]
                          )
                        ]
                      )
                    ]),
                    _c("tr", [
                      _c(
                        "td",
                        {
                          attrs: { rowspan: "2", colspan: "1", width: "80px" }
                        },
                        [_vm._v("时间")]
                      ),
                      _c(
                        "td",
                        {
                          attrs: { rowspan: "2", colspan: "1", width: "60px" }
                        },
                        [_vm._v("油罐")]
                      ),
                      _c(
                        "td",
                        {
                          attrs: { rowspan: "2", colspan: "1", width: "30px" }
                        },
                        [_vm._v("油品")]
                      ),
                      _c(
                        "td",
                        {
                          attrs: { rowspan: "2", colspan: "1", width: "80px" }
                        },
                        [_vm._v("供应商")]
                      ),
                      _c(
                        "td",
                        {
                          attrs: { rowspan: "2", colspan: "1", width: "100px" }
                        },
                        [_vm._v("发油单位")]
                      ),
                      !_vm.previewState
                        ? _c(
                            "td",
                            {
                              attrs: {
                                rowspan: "2",
                                colspan: "1",
                                width: "120px"
                              }
                            },
                            [_vm._v("提油单号")]
                          )
                        : _vm._e(),
                      !_vm.previewState
                        ? _c(
                            "td",
                            {
                              attrs: {
                                rowspan: "2",
                                colspan: "1",
                                width: "120px"
                              }
                            },
                            [_vm._v("运输单号")]
                          )
                        : _vm._e(),
                      _c(
                        "td",
                        {
                          attrs: { rowspan: "2", colspan: "1", width: "60px" }
                        },
                        [
                          _c("el-tooltip", { attrs: { placement: "top" } }, [
                            _c(
                              "div",
                              {
                                staticClass: "tips-content",
                                attrs: { slot: "content" },
                                slot: "content"
                              },
                              [
                                _c("span", [
                                  _vm._v("实际温度计测温度"),
                                  _c("br"),
                                  _vm._v("(温度计显示温度)")
                                ])
                              ]
                            ),
                            _c("span", [
                              _vm._v("油温"),
                              _c("br"),
                              _vm._v("（视温℃）")
                            ])
                          ])
                        ],
                        1
                      ),
                      _c(
                        "td",
                        { attrs: { rowspan: "2", colspan: "1", width: "60" } },
                        [
                          _c("el-tooltip", { attrs: { placement: "top" } }, [
                            _c(
                              "div",
                              {
                                staticClass: "tips-content",
                                attrs: { slot: "content" },
                                slot: "content"
                              },
                              [
                                _c("span", [
                                  _vm._v("对应视温密度，填写小数点后4位")
                                ])
                              ]
                            ),
                            _c("span", [
                              _vm._v("到站密度"),
                              _c("br"),
                              _vm._v("（视密）")
                            ])
                          ])
                        ],
                        1
                      ),
                      _c(
                        "td",
                        {
                          attrs: { rowspan: "2", colspan: "1", width: "60px" }
                        },
                        [_vm._v("计算密度"), _c("br"), _vm._v("（标密）")]
                      ),
                      _c("td", { attrs: { rowspan: "1", colspan: "5" } }, [
                        _vm._v("提油单吨数")
                      ]),
                      _c("td", { attrs: { rowspan: "1", colspan: "3" } }, [
                        _vm._v("到站入库")
                      ]),
                      _c("td", { attrs: { rowspan: "1", colspan: "3" } }, [
                        _vm._v("卸油前")
                      ]),
                      _c("td", { attrs: { rowspan: "1", colspan: "3" } }, [
                        _vm._v("卸油后")
                      ]),
                      _c(
                        "td",
                        {
                          attrs: { rowspan: "2", colspan: "1", width: "60px" }
                        },
                        [
                          _c("el-tooltip", { attrs: { placement: "top" } }, [
                            _c(
                              "div",
                              {
                                staticClass: "tips-content",
                                attrs: { slot: "content" },
                                slot: "content"
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    "系统点击【开始卸油】到【结束卸油】时间内的销售升数"
                                  )
                                ])
                              ]
                            ),
                            _c("span", [
                              _vm._v("卸油期间内"),
                              _c("br"),
                              _vm._v("销量（升）")
                            ])
                          ])
                        ],
                        1
                      ),
                      _c(
                        "td",
                        {
                          attrs: { rowspan: "2", colspan: "1", width: "60px" }
                        },
                        [
                          _c("el-tooltip", { attrs: { placement: "top" } }, [
                            _c(
                              "div",
                              {
                                staticClass: "tips-content",
                                attrs: { slot: "content" },
                                slot: "content"
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    "卸油后升数 - 卸油前升数 + 卸油期间销售升数"
                                  )
                                ])
                              ]
                            ),
                            _c("span", [
                              _vm._v("油罐实收"),
                              _c("br"),
                              _vm._v("（升）")
                            ])
                          ])
                        ],
                        1
                      ),
                      _c(
                        "td",
                        {
                          attrs: { rowspan: "2", colspan: "1", width: "60px" }
                        },
                        [
                          _c("el-tooltip", { attrs: { placement: "top" } }, [
                            _c(
                              "div",
                              {
                                staticClass: "tips-content",
                                attrs: { slot: "content" },
                                slot: "content"
                              },
                              [_c("span", [_vm._v("油罐实收-分卸升数")])]
                            ),
                            _c("span", [
                              _vm._v("验收损益"),
                              _c("br"),
                              _vm._v("（升）")
                            ])
                          ])
                        ],
                        1
                      ),
                      _c(
                        "td",
                        {
                          attrs: {
                            rowspan: "2",
                            colspan: "1",
                            width: _vm.previewState ? "" : "60px"
                          }
                        },
                        [
                          _c("el-tooltip", { attrs: { placement: "top" } }, [
                            _c(
                              "div",
                              {
                                staticClass: "tips-content",
                                attrs: { slot: "content" },
                                slot: "content"
                              },
                              [_c("span", [_vm._v("备注哪个油站分卸多少吨")])]
                            ),
                            _c("span", [_vm._v("备注情况")])
                          ])
                        ],
                        1
                      )
                    ]),
                    _c("tr", [
                      _c(
                        "td",
                        { attrs: { colspan: "1", width: "60px" } },
                        [
                          _c("el-tooltip", { attrs: { placement: "top" } }, [
                            _c(
                              "div",
                              {
                                staticClass: "tips-content",
                                attrs: { slot: "content" },
                                slot: "content"
                              },
                              [_c("span", [_vm._v("油库出库单上的吨数")])]
                            ),
                            _c("span", [_vm._v("总吨数")])
                          ])
                        ],
                        1
                      ),
                      _c(
                        "td",
                        { attrs: { colspan: "1", width: "60px" } },
                        [
                          _c("el-tooltip", { attrs: { placement: "top" } }, [
                            _c(
                              "div",
                              {
                                staticClass: "tips-content",
                                attrs: { slot: "content" },
                                slot: "content"
                              },
                              [
                                _c("span", [
                                  _vm._v("油库出库单上的吨数 / 视密 * 1000")
                                ])
                              ]
                            ),
                            _c("span", [_vm._v("总升数")])
                          ])
                        ],
                        1
                      ),
                      _c(
                        "td",
                        { attrs: { colspan: "1", width: "60px" } },
                        [
                          _c("el-tooltip", { attrs: { placement: "top" } }, [
                            _c(
                              "div",
                              {
                                staticClass: "tips-content",
                                attrs: { slot: "content" },
                                slot: "content"
                              },
                              [
                                _c("span", [
                                  _vm._v("分卸吨数=本站分卸的提油单吨数")
                                ])
                              ]
                            ),
                            _c("span", [_vm._v("分卸吨数")])
                          ])
                        ],
                        1
                      ),
                      _c(
                        "td",
                        { attrs: { colspan: "1", width: "60px" } },
                        [
                          _c("el-tooltip", { attrs: { placement: "top" } }, [
                            _c(
                              "div",
                              {
                                staticClass: "tips-content",
                                attrs: { slot: "content" },
                                slot: "content"
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    "分卸升数（油库出油升数）= 吨数 / 视密 * 1000"
                                  )
                                ])
                              ]
                            ),
                            _c("span", [_vm._v("分卸升数")])
                          ])
                        ],
                        1
                      ),
                      _c("td", { attrs: { colspan: "1", width: "60px" } }, [
                        _vm._v("罐车验收升数")
                      ]),
                      _c("td", { attrs: { colspan: "1", width: "60px" } }, [
                        _vm._v("实磅吨数")
                      ]),
                      _c("td", { attrs: { colspan: "1", width: "60px" } }, [
                        _vm._v("实磅升数")
                      ]),
                      _c(
                        "td",
                        { attrs: { colspan: "1", width: "60px" } },
                        [
                          _c("el-tooltip", { attrs: { placement: "top" } }, [
                            _c(
                              "div",
                              {
                                staticClass: "tips-content",
                                attrs: { slot: "content" },
                                slot: "content"
                              },
                              [
                                _c("span", [
                                  _vm._v("损耗升数=实磅升数-分卸升数")
                                ])
                              ]
                            ),
                            _c("span", [_vm._v("损耗升数")])
                          ])
                        ],
                        1
                      ),
                      _c("td", { attrs: { colspan: "1", width: "60px" } }, [
                        _vm._v("油罐温度"),
                        _c("br"),
                        _vm._v("（℃）")
                      ]),
                      _c("td", { attrs: { colspan: "1", width: "60px" } }, [
                        _vm._v("尺高度"),
                        _c("br"),
                        _vm._v("（mm）")
                      ]),
                      _c("td", { attrs: { colspan: "1", width: "60px" } }, [
                        _vm._v("尺升数"),
                        _c("br"),
                        _vm._v("（升）")
                      ]),
                      _c("td", { attrs: { colspan: "1", width: "60px" } }, [
                        _vm._v("油罐温度"),
                        _c("br"),
                        _vm._v("（℃）")
                      ]),
                      _c("td", { attrs: { colspan: "1", width: "60px" } }, [
                        _vm._v("尺高度"),
                        _c("br"),
                        _vm._v("（mm）")
                      ]),
                      _c("td", { attrs: { colspan: "1", width: "60px" } }, [
                        _vm._v("尺升数"),
                        _c("br"),
                        _vm._v("（升）")
                      ])
                    ]),
                    _vm._l(_vm.formTable, function(item, index) {
                      return _c("tr", { key: index }, [
                        _c("td", { class: { "table-bg": !_vm.previewState } }, [
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm._f("formatDate3")(
                                  _vm.formTable[index].oilStartAt
                                )
                              )
                            )
                          ]),
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm._f("formatDate3")(
                                  _vm.formTable[index].oilEndAt
                                )
                              )
                            )
                          ])
                        ]),
                        _c("td", { class: { "table-bg": !_vm.previewState } }, [
                          _vm._v(
                            " " + _vm._s(_vm.formTable[index].tankNum) + "号灌 "
                          )
                        ]),
                        _c("td", { class: { "table-bg": !_vm.previewState } }, [
                          _vm._v(
                            " " + _vm._s(_vm.formTable[index].oilCode) + "# "
                          )
                        ]),
                        _c("td", [
                          _vm.previewState
                            ? _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.getBasicData(
                                        _vm.supplierList,
                                        _vm.formTable[index].oilSupplierNo,
                                        "oilSupplierNo",
                                        "supplierName"
                                      )
                                    ) +
                                    " "
                                )
                              ])
                            : _c(
                                "div",
                                [
                                  _c(
                                    "el-form",
                                    { attrs: { model: _vm.formTable[index] } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: {
                                            margin: "0",
                                            padding: "0"
                                          },
                                          attrs: { "label-width": "0" }
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticClass:
                                                "paperview-input-text",
                                              attrs: {
                                                filterable: "",
                                                clearable: "",
                                                placeholder: "请选择"
                                              },
                                              model: {
                                                value:
                                                  _vm.formTable[index]
                                                    .oilSupplierNo,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.formTable[index],
                                                    "oilSupplierNo",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formTable[index].oilSupplierNo"
                                              }
                                            },
                                            _vm._l(_vm.supplierList, function(
                                              item
                                            ) {
                                              return _c("el-option", {
                                                key: item.ID,
                                                attrs: {
                                                  label: item.supplierName,
                                                  value: item.oilSupplierNo
                                                }
                                              })
                                            }),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                        ]),
                        _c("td", [
                          _vm.previewState
                            ? _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.getBasicData(
                                        _vm.oildepotList,
                                        _vm.formTable[index].depotNo,
                                        "depotNo",
                                        "depotName"
                                      )
                                    ) +
                                    " "
                                )
                              ])
                            : _c(
                                "div",
                                [
                                  _c(
                                    "el-form",
                                    { attrs: { model: _vm.formTable[index] } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: {
                                            margin: "0",
                                            padding: "0"
                                          },
                                          attrs: { "label-width": "0" }
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticClass:
                                                "paperview-input-text",
                                              attrs: {
                                                filterable: "",
                                                clearable: "",
                                                placeholder: "请选择"
                                              },
                                              model: {
                                                value:
                                                  _vm.formTable[index].depotNo,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.formTable[index],
                                                    "depotNo",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formTable[index].depotNo"
                                              }
                                            },
                                            _vm._l(_vm.oildepotList, function(
                                              item
                                            ) {
                                              return _c("el-option", {
                                                key: item.ID,
                                                attrs: {
                                                  label: item.depotName,
                                                  value: item.depotNo
                                                }
                                              })
                                            }),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                        ]),
                        !_vm.previewState
                          ? _c("td", [
                              _vm.previewState
                                ? _c("div", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.formTable[index]
                                            .withdrawalTicketNo
                                        ) +
                                        " "
                                    )
                                  ])
                                : _c(
                                    "div",
                                    [
                                      _c(
                                        "el-form",
                                        {
                                          attrs: { model: _vm.formTable[index] }
                                        },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              staticStyle: {
                                                margin: "0",
                                                padding: "0"
                                              },
                                              attrs: { "label-width": "0" }
                                            },
                                            [
                                              _c("el-input", {
                                                staticClass:
                                                  "paperview-input-text",
                                                attrs: {
                                                  placeholder: "请填写"
                                                },
                                                model: {
                                                  value:
                                                    _vm.formTable[index]
                                                      .withdrawalTicketNo,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formTable[index],
                                                      "withdrawalTicketNo",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formTable[index].withdrawalTicketNo"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                            ])
                          : _vm._e(),
                        !_vm.previewState
                          ? _c("td", [
                              _vm.previewState
                                ? _c("div", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.formTable[index].transportNo
                                        ) +
                                        " "
                                    )
                                  ])
                                : _c(
                                    "div",
                                    [
                                      _c(
                                        "el-form",
                                        {
                                          attrs: { model: _vm.formTable[index] }
                                        },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              staticStyle: {
                                                margin: "0",
                                                padding: "0"
                                              },
                                              attrs: { "label-width": "0" }
                                            },
                                            [
                                              _c(
                                                "el-select",
                                                {
                                                  staticClass:
                                                    "paperview-input-text",
                                                  attrs: {
                                                    filterable: "",
                                                    clearable: "",
                                                    placeholder: "请选择"
                                                  },
                                                  on: {
                                                    change: _vm.fleetcarChange
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formTable[index]
                                                        .transportNo,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.formTable[index],
                                                        "transportNo",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formTable[index].transportNo"
                                                  }
                                                },
                                                _vm._l(
                                                  _vm.transportList,
                                                  function(item) {
                                                    return _c("el-option", {
                                                      key: item.ID,
                                                      attrs: {
                                                        label:
                                                          item.transportName,
                                                        value: item.transportNo
                                                      }
                                                    })
                                                  }
                                                ),
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                            ])
                          : _vm._e(),
                        _c("td", [
                          _vm.previewState
                            ? _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.formTable[index].oilTemperature
                                    ) +
                                    " "
                                )
                              ])
                            : _c(
                                "div",
                                [
                                  _c(
                                    "el-form",
                                    { attrs: { model: _vm.formTable[index] } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: {
                                            margin: "0",
                                            padding: "0"
                                          },
                                          attrs: { "label-width": "0" }
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass: "paperview-input-text",
                                            attrs: { placeholder: "请填写" },
                                            nativeOn: {
                                              input: function($event) {
                                                return _vm.onInputDecimal(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.formTable[index]
                                                  .oilTemperature,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formTable[index],
                                                  "oilTemperature",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formTable[index].oilTemperature"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                        ]),
                        _c("td", [
                          _vm.previewState
                            ? _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.formTable[index].oilDensity) +
                                    " "
                                )
                              ])
                            : _c(
                                "div",
                                [
                                  _c(
                                    "el-form",
                                    { attrs: { model: _vm.formTable[index] } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: {
                                            margin: "0",
                                            padding: "0"
                                          },
                                          attrs: { "label-width": "0" }
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass: "paperview-input-text",
                                            attrs: { placeholder: "请填写" },
                                            nativeOn: {
                                              input: function($event) {
                                                return _vm.onInputDecimal(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.formTable[index].oilDensity,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formTable[index],
                                                  "oilDensity",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formTable[index].oilDensity"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                        ]),
                        _c("td", { class: { "table-bg": !_vm.previewState } }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.formTable[index].oilStandardDensity) +
                              " "
                          )
                        ]),
                        _c("td", [
                          _vm.previewState
                            ? _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.formTable[index].transportOilTon
                                    ) +
                                    " "
                                )
                              ])
                            : _c(
                                "div",
                                [
                                  _c(
                                    "el-form",
                                    { attrs: { model: _vm.formTable[index] } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: {
                                            margin: "0",
                                            padding: "0"
                                          },
                                          attrs: { "label-width": "0" }
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass: "paperview-input-text",
                                            attrs: { placeholder: "请填写" },
                                            nativeOn: {
                                              input: function($event) {
                                                return _vm.onInputDecimal(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.formTable[index]
                                                  .transportOilTon,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formTable[index],
                                                  "transportOilTon",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formTable[index].transportOilTon"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                        ]),
                        _c("td", { class: { "table-bg": !_vm.previewState } }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.formTable[index].transportOilLiters) +
                              " "
                          )
                        ]),
                        _c("td", [
                          _vm.previewState
                            ? _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.formTable[index].giveInTon) +
                                    " "
                                )
                              ])
                            : _c(
                                "div",
                                [
                                  _c(
                                    "el-form",
                                    { attrs: { model: _vm.formTable[index] } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: {
                                            margin: "0",
                                            padding: "0"
                                          },
                                          attrs: { "label-width": "0" }
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass: "paperview-input-text",
                                            attrs: { placeholder: "请填写" },
                                            nativeOn: {
                                              input: function($event) {
                                                return _vm.onInputDecimal(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.formTable[index].giveInTon,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formTable[index],
                                                  "giveInTon",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formTable[index].giveInTon"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                        ]),
                        _c("td", { class: { "table-bg": !_vm.previewState } }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.formTable[index].giveInLiters) +
                              " "
                          )
                        ]),
                        _c("td", [
                          _vm.previewState
                            ? _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.formTable[index].giveInCompareLiters
                                    ) +
                                    " "
                                )
                              ])
                            : _c(
                                "div",
                                [
                                  _c(
                                    "el-form",
                                    { attrs: { model: _vm.formTable[index] } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: {
                                            margin: "0",
                                            padding: "0"
                                          },
                                          attrs: { "label-width": "0" }
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass: "paperview-input-text",
                                            attrs: { placeholder: "请填写" },
                                            nativeOn: {
                                              input: function($event) {
                                                return _vm.onInputDecimal(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.formTable[index]
                                                  .giveInCompareLiters,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formTable[index],
                                                  "giveInCompareLiters",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formTable[index].giveInCompareLiters"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                        ]),
                        _c("td", [
                          _vm.previewState
                            ? _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.formTable[index].oilInTon) +
                                    " "
                                )
                              ])
                            : _c(
                                "div",
                                [
                                  _c(
                                    "el-form",
                                    { attrs: { model: _vm.formTable[index] } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: {
                                            margin: "0",
                                            padding: "0"
                                          },
                                          attrs: { "label-width": "0" }
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass: "paperview-input-text",
                                            attrs: { placeholder: "请填写" },
                                            nativeOn: {
                                              input: function($event) {
                                                return _vm.onInputDecimal(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.formTable[index].oilInTon,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formTable[index],
                                                  "oilInTon",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formTable[index].oilInTon"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                        ]),
                        _c("td", { class: { "table-bg": !_vm.previewState } }, [
                          _vm._v(
                            " " + _vm._s(_vm.formTable[index].oilInLiters) + " "
                          )
                        ]),
                        _c("td", { class: { "table-bg": !_vm.previewState } }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.formTable[index].giveLossLiters) +
                              " "
                          )
                        ]),
                        _c("td", [
                          _vm.previewState
                            ? _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.formTable[index].beforeTankTemperature
                                    ) +
                                    " "
                                )
                              ])
                            : _c(
                                "div",
                                [
                                  _c(
                                    "el-form",
                                    { attrs: { model: _vm.formTable[index] } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: {
                                            margin: "0",
                                            padding: "0"
                                          },
                                          attrs: { "label-width": "0" }
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass: "paperview-input-text",
                                            attrs: { placeholder: "请填写" },
                                            nativeOn: {
                                              input: function($event) {
                                                return _vm.onInputDecimal(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.formTable[index]
                                                  .beforeTankTemperature,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formTable[index],
                                                  "beforeTankTemperature",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formTable[index].beforeTankTemperature"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                        ]),
                        _c("td", [
                          _vm.previewState
                            ? _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.formTable[index].beforeOilHeight
                                    ) +
                                    " "
                                )
                              ])
                            : _c(
                                "div",
                                [
                                  _c(
                                    "el-form",
                                    { attrs: { model: _vm.formTable[index] } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: {
                                            margin: "0",
                                            padding: "0"
                                          },
                                          attrs: { "label-width": "0" }
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass: "paperview-input-text",
                                            attrs: { placeholder: "请填写" },
                                            nativeOn: {
                                              input: function($event) {
                                                return _vm.onInputDecimal(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.formTable[index]
                                                  .beforeOilHeight,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formTable[index],
                                                  "beforeOilHeight",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formTable[index].beforeOilHeight"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                        ]),
                        _c("td", [
                          _vm.previewState
                            ? _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.formTable[index].beforeOilCapacity
                                    ) +
                                    " "
                                )
                              ])
                            : _c(
                                "div",
                                [
                                  _c(
                                    "el-form",
                                    { attrs: { model: _vm.formTable[index] } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: {
                                            margin: "0",
                                            padding: "0"
                                          },
                                          attrs: { "label-width": "0" }
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass: "paperview-input-text",
                                            attrs: { placeholder: "请填写" },
                                            nativeOn: {
                                              input: function($event) {
                                                return _vm.onInputDecimal(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.formTable[index]
                                                  .beforeOilCapacity,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formTable[index],
                                                  "beforeOilCapacity",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formTable[index].beforeOilCapacity"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                        ]),
                        _c("td", [
                          _vm.previewState
                            ? _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.formTable[index].afterTankTemperature
                                    ) +
                                    " "
                                )
                              ])
                            : _c(
                                "div",
                                [
                                  _c(
                                    "el-form",
                                    { attrs: { model: _vm.formTable[index] } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: {
                                            margin: "0",
                                            padding: "0"
                                          },
                                          attrs: { "label-width": "0" }
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass: "paperview-input-text",
                                            attrs: { placeholder: "请填写" },
                                            nativeOn: {
                                              input: function($event) {
                                                return _vm.onInputDecimal(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.formTable[index]
                                                  .afterTankTemperature,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formTable[index],
                                                  "afterTankTemperature",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formTable[index].afterTankTemperature"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                        ]),
                        _c("td", [
                          _vm.previewState
                            ? _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.formTable[index].afterOilHeight
                                    ) +
                                    " "
                                )
                              ])
                            : _c(
                                "div",
                                [
                                  _c(
                                    "el-form",
                                    { attrs: { model: _vm.formTable[index] } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: {
                                            margin: "0",
                                            padding: "0"
                                          },
                                          attrs: { "label-width": "0" }
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass: "paperview-input-text",
                                            attrs: { placeholder: "请填写" },
                                            nativeOn: {
                                              input: function($event) {
                                                return _vm.onInputDecimal(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.formTable[index]
                                                  .afterOilHeight,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formTable[index],
                                                  "afterOilHeight",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formTable[index].afterOilHeight"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                        ]),
                        _c("td", [
                          _vm.previewState
                            ? _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.formTable[index].afterOilCapacity
                                    ) +
                                    " "
                                )
                              ])
                            : _c(
                                "div",
                                [
                                  _c(
                                    "el-form",
                                    { attrs: { model: _vm.formTable[index] } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: {
                                            margin: "0",
                                            padding: "0"
                                          },
                                          attrs: { "label-width": "0" }
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass: "paperview-input-text",
                                            attrs: { placeholder: "请填写" },
                                            nativeOn: {
                                              input: function($event) {
                                                return _vm.onInputDecimal(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.formTable[index]
                                                  .afterOilCapacity,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formTable[index],
                                                  "afterOilCapacity",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formTable[index].afterOilCapacity"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                        ]),
                        _c("td", { class: { "table-bg": !_vm.previewState } }, [
                          _vm._v(
                            " " + _vm._s(_vm.formTable[index].oilSales) + " "
                          )
                        ]),
                        _c("td", { class: { "table-bg": !_vm.previewState } }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.formTable[index].sequenceInLiters) +
                              " "
                          )
                        ]),
                        _c("td", { class: { "table-bg": !_vm.previewState } }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.formTable[index].oilLossLiters) +
                              " "
                          )
                        ]),
                        _c("td", [
                          _vm.previewState
                            ? _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.formTable[index].remark) +
                                    " "
                                )
                              ])
                            : _c(
                                "div",
                                [
                                  _c(
                                    "el-form",
                                    { attrs: { model: _vm.formTable[index] } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticStyle: {
                                            margin: "0",
                                            padding: "0"
                                          },
                                          attrs: { "label-width": "0" }
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass: "paperview-input-text",
                                            staticStyle: { width: "88px" },
                                            attrs: { placeholder: "请填写" },
                                            model: {
                                              value:
                                                _vm.formTable[index].remark,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formTable[index],
                                                  "remark",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formTable[index].remark"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                        ])
                      ])
                    }),
                    _vm.previewState
                      ? _c(
                          "tr",
                          [
                            _vm._l(_vm.formTable, function(item, index) {
                              return _c(
                                "td",
                                {
                                  key: index,
                                  staticStyle: { padding: "10px" },
                                  attrs: { colspan: index == 0 ? "4" : "2" }
                                },
                                [
                                  _vm._v(
                                    " 卸入 " +
                                      _vm._s(_vm.formTable[index].oilCode) +
                                      "# 油罐 "
                                  )
                                ]
                              )
                            }),
                            _c(
                              "td",
                              {
                                attrs: {
                                  colspan:
                                    _vm.colspanNum -
                                    _vm.formTable.length * 2 -
                                    2
                                }
                              },
                              [_vm._v(" 合计卸入油罐 ")]
                            )
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm.previewState
                      ? _c(
                          "tr",
                          [
                            _vm._l(_vm.tableFootData, function(item, index) {
                              return _c(
                                "td",
                                {
                                  key: index,
                                  attrs: {
                                    colspan:
                                      index == 0 || index == 1 ? "2" : "1"
                                  }
                                },
                                [_vm._v(" " + _vm._s(item.label) + " ")]
                              )
                            }),
                            _c(
                              "td",
                              {
                                attrs: {
                                  colspan:
                                    (_vm.colspanNum -
                                      _vm.formTable.length * 2 -
                                      2) /
                                    2
                                }
                              },
                              [_vm._v(" 吨数 ")]
                            ),
                            _c(
                              "td",
                              {
                                attrs: {
                                  colspan:
                                    (_vm.colspanNum -
                                      _vm.formTable.length * 2 -
                                      2) /
                                    2
                                }
                              },
                              [_vm._v(" 升数 ")]
                            )
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm.previewState
                      ? _c(
                          "tr",
                          [
                            _vm._l(_vm.tableFootData, function(item, index) {
                              return _c(
                                "td",
                                {
                                  key: index,
                                  attrs: {
                                    colspan:
                                      index == 0 || index == 1 ? "2" : "1"
                                  }
                                },
                                [_vm._v(" " + _vm._s(item.value) + " ")]
                              )
                            }),
                            _c(
                              "td",
                              {
                                attrs: {
                                  colspan:
                                    (_vm.colspanNum -
                                      _vm.formTable.length * 2 -
                                      2) /
                                    2
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.count(_vm.tableFootData, 0).toFixed(2)
                                    ) +
                                    " "
                                )
                              ]
                            ),
                            _c(
                              "td",
                              {
                                attrs: {
                                  colspan:
                                    (_vm.colspanNum -
                                      _vm.formTable.length * 2 -
                                      2) /
                                    2
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.count(_vm.tableFootData, 1).toFixed(2)
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ],
                          2
                        )
                      : _vm._e()
                  ],
                  2
                ),
                _c(
                  "table",
                  {
                    staticStyle: { border: "none", "text-align": "left" },
                    attrs: { width: _vm.previewState ? "1880" : "2180" }
                  },
                  [
                    _vm.previewState
                      ? _c("tr", { staticStyle: { border: "none" } }, [
                          _c(
                            "td",
                            {
                              staticStyle: { border: "none" },
                              attrs: { width: "300" }
                            },
                            [_vm._v(" 油站经理： ")]
                          ),
                          _c(
                            "td",
                            {
                              staticStyle: { border: "none" },
                              attrs: { width: "300" }
                            },
                            [
                              _c(
                                "el-tooltip",
                                { attrs: { placement: "top" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "tips-content",
                                      attrs: { slot: "content" },
                                      slot: "content"
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "如果有换司机，换班司机也要签名，要在签名下注明油库到油站或油站到油站"
                                        )
                                      ])
                                    ]
                                  ),
                                  _c("span", [_vm._v("司机：")])
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "td",
                            {
                              staticStyle: { border: "none" },
                              attrs: { width: "300" }
                            },
                            [
                              _c(
                                "el-tooltip",
                                { attrs: { placement: "top" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "tips-content",
                                      attrs: { slot: "content" },
                                      slot: "content"
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "如果有换司机，换班司机也要签名，要在签名下注明油库到油站或油站到油站"
                                        )
                                      ])
                                    ]
                                  ),
                                  _c("span", [_vm._v("押运：")])
                                ]
                              )
                            ],
                            1
                          ),
                          _c("td", { staticStyle: { border: "none" } }, [
                            _vm._v(" ")
                          ])
                        ])
                      : _vm._e()
                  ]
                )
              ]),
              _vm.previewState
                ? _c("div", [
                    _c("div", { staticStyle: { "margin-top": "10px" } }, [
                      _vm._v(" 备注： ")
                    ]),
                    _c(
                      "div",
                      { staticStyle: { "margin-top": "10px", color: "red" } },
                      [_vm._v(" 1.如果过不了磅，实磅吨数填油单吨数 ")]
                    ),
                    _c(
                      "div",
                      { staticStyle: { "margin-top": "5px", color: "red" } },
                      [_vm._v(" 2.此表全部按视密计算升数 ")]
                    )
                  ])
                : _vm._e(),
              !_vm.previewState
                ? _c("div", [
                    _c("div", { staticStyle: { "margin-top": "10px" } }, [
                      _vm._v(" 提示： ")
                    ]),
                    _c(
                      "div",
                      { staticStyle: { "margin-top": "10px", color: "red" } },
                      [_vm._v(" 1.灰色单元格表示无须输入 ")]
                    ),
                    _c(
                      "div",
                      { staticStyle: { "margin-top": "5px", color: "red" } },
                      [_vm._v(" 2.鼠标悬停标题可看描述 ")]
                    ),
                    _c(
                      "div",
                      { staticStyle: { "margin-top": "5px", color: "red" } },
                      [_vm._v(" 3.表格可以左右滑动 ")]
                    )
                  ])
                : _vm._e()
            ],
            1
          ),
          !_vm.previewState
            ? _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c("el-button", { on: { click: _vm.dialogCancel } }, [
                    _vm._v("取 消")
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.dialogConfirm(1)
                        }
                      }
                    },
                    [_vm._v("暂 存")]
                  ),
                  _c(
                    "el-tooltip",
                    { attrs: { placement: "top" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "tips-content",
                          attrs: { slot: "content" },
                          slot: "content"
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "操作后不能再继续卸油，请完成所有卸油后再操作"
                            )
                          ])
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.allFinished }
                        },
                        [_vm._v("保存并重新计算")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        2
      ),
      _c("el-pagination", {
        style: { float: "right", padding: "20px" },
        attrs: {
          "current-page": _vm.page,
          "page-size": _vm.pageSize,
          "page-sizes": [10, 30, 50, 100],
          total: _vm.total,
          layout: "total, sizes, prev, pager, next, jumper"
        },
        on: {
          "current-change": _vm.handleCurrentChange,
          "size-change": _vm.handleSizeChange
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }